import { createBrowserRouter } from "react-router";
import Layout from "./pages/Layout";
import Layout_Banner_2 from "./pages/Layout_Banner_2";
import Layout_Banner_3 from "./pages/Layout_Banner_3";
import Layout_Banner_4 from "./pages/Layout_Banner_4";
import Layout_Home from "./pages/Layout_Home";
import Layout_About from "./pages/Layour_About";
import Layout_Sponsor from "./pages/Layout_Sponsor";
import Home from "./pages/Home";
import About from "./pages/About"
import CallForPapers from "./pages/CallForPapers"
import MasterclassesWorkshops from "./pages/MasterclassesWorkshops"
import Registration from "./pages/Registration"
import SponsorshipExhibition from "./pages/SponsorshipExhibition"
import VenueAccommodation from "./pages/VenueAccommodation"
import ProgramOutline from "./pages/ProgramOutline"
import ContactUs from "./pages/ContactUs"
// import OrganisingCommittee from "./pages/OrganisingCommittee";

const router = createBrowserRouter([
    {
        Component: Layout_Home,
        children: [
            {
                index: true, Component: Home,
            },
        ]
    },
    {
        Component: Layout,
        children: [
            {
                path: "/call-for-papers", Component: CallForPapers
            },
        ]
    },
    {
        Component: Layout_Sponsor,
        children: [
            {
                path: "/sponsorship-exhibition", Component: SponsorshipExhibition
            },
        ]
    },
    {
        Component: Layout_Banner_2,
        children: [
            { path: "/registration", Component: Registration },
            // { path: "/committee", Component: OrganisingCommittee },
        ]
    },
    {
        Component: Layout_About,
        children: [
            { path: "/about", Component: About },
        ]
    },
    {
        Component: Layout_Banner_3,
        children: [
            { path: "/masterclasses-workshops", Component: MasterclassesWorkshops },
            { path: "/program-outline", Component: ProgramOutline },
        ]
    },
    {
        Component: Layout_Banner_4,
        children: [
            { path: "/venue-accommodation", Component: VenueAccommodation },
            { path: "/contact-us", Component: ContactUs },
        ]
    },
]);

export default router